import React, { useContext, useEffect, useState } from 'react'
import { SettingTab } from '@/components/molecules/settings/setting-tab'
import { listContainerStyle } from '@/constants/layout'
import { css } from '@emotion/core'
import * as pluginGetter from '@/libs/plugins'
import { AccountContext } from '@/contexts/account'

export const CheckinTabContainer: React.FC<{
  currentTab: 'Checkin' | 'Tablet Checkout' | 'Question' | 'Time selection' | 'Card reader' | 'Terminal' | 'CashChanger'
}> = ({ currentTab, children }) => {
  const { plugins } = useContext<any>(AccountContext)
  const [tabs, setTabs] = useState<Array<{ name: string; path: string }>>([])

  useEffect(() => {
    const hasCustomCheckinPlugin = pluginGetter.setHasCustomCheckinPlugin(plugins)
    const hasSelfCheckinPlugin = pluginGetter.setHasSelfCheckinPlugin(plugins)
    const canUseCheckinSetting = pluginGetter.canUseCheckinSetting(plugins)
    const hasCardReaderPlugin = pluginGetter.hasCardReaderPlugin(plugins)
    const hasPaymentTerminalPlugin = pluginGetter.checkActivePlugin(plugins, pluginGetter.PluginCode.PaymentTerminal)
    const hasCustomCheckinTimeSelectionPlugin = pluginGetter.checkActivePlugin(plugins, pluginGetter.PluginCode.CheckinTimeSelection)
    const enableTabs: Array<{ name: string; path: string }> = []
    if (canUseCheckinSetting) {
      enableTabs.push({
        name: 'Checkin',
        path: '/setting/checkin/self-checkin',
      })
    }
    if (hasSelfCheckinPlugin) {
      enableTabs.push({
        name: 'Tablet Checkout',
        path: '/setting/checkin/self-checkout',
      })
    }
    if (hasCustomCheckinPlugin) {
      enableTabs.push({
        name: 'Question',
        path: '/setting/checkin/custom-checkin',
      })
    }
    if (hasCustomCheckinTimeSelectionPlugin) {
      enableTabs.push({
        name: 'Time selection',
        path: '/setting/checkin/time-selection',
      })
    }
    if (hasCardReaderPlugin) {
      enableTabs.push({
        name: 'Card reader',
        path: '/setting/checkin/card-reader',
      })
    }
    if (hasPaymentTerminalPlugin) {
      enableTabs.push({
        name: 'Terminal',
        path: '/setting/checkin/terminal',
      })
      enableTabs.push({
        name: 'CashChanger',
        path: '/setting/checkin/cash-changer',
      })
    }
    setTabs(enableTabs)
  }, [plugins])

  return (
    <SettingTab currentTab={currentTab} tabs={tabs} customTabStyle={css({ width: 160 })}>
      <div css={topImageContainerStyle}>{children}</div>
    </SettingTab>
  )
}

const topImageContainerStyle = css(listContainerStyle, {
  width: '100%',
  background: '#FFF',
  minHeight: 'auto',
  marginBottom: -10,
})
